// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"365":"cc47d1d6","685":"adc85472"}[chunkId] + ".chunk.css";
};